import React from "react";
import TableCell from "@material-ui/core/TableCell";
import PropTypes from "prop-types";
import TableSortLabel from "@material-ui/core/TableSortLabel";

const HeaderCell = ({ orderBy, orderName, onChangeOrdering = () => {}, children, colspan }) => {
  const existsOrderingForColumn = Boolean(orderBy) && orderBy.hasOwnProperty(orderName);
  return (
    <TableCell colSpan={colspan}>
      {existsOrderingForColumn ? (
        <TableSortLabel
          active
          direction={existsOrderingForColumn ? orderBy[orderName].toLowerCase() : "asc"}
          onClick={() => onChangeOrdering(orderName)}
        >
          {children}
        </TableSortLabel>
      ) : (
        children
      )}
    </TableCell>
  );
};

HeaderCell.propTypes = {
  /**
   ** Callback que se llama cuando cambia el orden de la columna
   **/
  onChangeOrdering: PropTypes.func,
  /**
   ** Nombre del campo de ordenación
   **/
  orderName: PropTypes.string,
  /**
   ** Objeto con clave: valor que representa las diferentes ordenaciones de la tabla
   **/
  orderBy: PropTypes.object,
  /**
   ** Colspan de la celda
   **/
  colspan: PropTypes.number,
};

export default HeaderCell;
